// 用户认证
import Service from '../base'
export default {
  token (user) {
    if (user) {
      user['grant_type'] = 'password'
    }
    return Service.post('/oauth/token', user)
  },
  refresh (token) {
    return Service.post('/oauth/token', {
      'grant_type': 'refresh_token',
      'refresh_token': token
    })
  },
  client () {
    return Service.post('/oauth/token', {'grant_type': 'client_credentials'})
  }
}
